import styles from "./UploadFile.module.scss";
import { ChangeEvent, useRef } from "react";
import editIcon from "../../assets/images/icons/edit.svg";
import useAppSelector from "../../hooks/useAppSelector";
import { UserService } from "../../services/user.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import { updateProfileImage } from "../../store/userProfile/userProfileSlice";
import { useTranslation } from "react-i18next";
import { openErrorMessage, openSuccessMessage } from "../../store/message/messageSlice";
import { handleError } from "../../helper/errorHandler";

const UploadFile = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { user } = useAppSelector((state) => state.userProfileSlice);
  const filePicker = useRef<HTMLInputElement>(null);

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (!user) return;

    if (!event.target.files) {
      dispatch(openErrorMessage(t("INVALID_FILES")));
      return;
    }

    const selectedFile = event.target.files[0];

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await UserService.changeProfileImage(user.id, formData);

      if (response.status === 200 && response.data) {
        dispatch(openSuccessMessage(t("ProfileImageUpdatedSuccessfully")));
        dispatch(updateProfileImage(response.data.profileImagePath));
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  const handleEditBtn = () => {
    if (filePicker.current) {
      filePicker.current.click();
    }
  };

  return (
    <div className={styles.container}>
      <button className={styles.editBtn} onClick={handleEditBtn}>
        <img src={editIcon} alt={"Edit"} />
      </button>
      <input
        className={styles.hidden}
        ref={filePicker}
        type={"file"}
        onChange={handleChange}
        accept={"image/*,.pmg,.jpg,.jpeg,"}
      />
    </div>
  );
};

export default UploadFile;
